import { render, staticRenderFns } from "./ViewMonitoringFeature.vue?vue&type=template&id=2d56f384"
import script from "./ViewMonitoringFeature.vue?vue&type=script&lang=js"
export * from "./ViewMonitoringFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports